import { useEffect, useMemo } from 'react';
import { useCreateBlockNote } from '@blocknote/react';
import { BlockNoteView } from '@blocknote/mantine';
import type { Block } from '@blocknote/core';
import '@blocknote/mantine/style.css';

const STORAGE_KEY_PREFIX = 'roadmap_2026_board_';
const STORAGE_KEY_SUFFIX = '_editor';

function getStorageKey(boardId: string) {
  return `${STORAGE_KEY_PREFIX}${boardId}${STORAGE_KEY_SUFFIX}`;
}

function loadContent(boardId: string): Block[] | undefined {
  try {
    const raw = localStorage.getItem(getStorageKey(boardId));
    if (raw) {
      return JSON.parse(raw) as Block[];
    }
  } catch {
    // ignore parse errors
  }
  return undefined;
}

function saveContent(boardId: string, blocks: Block[]) {
  localStorage.setItem(getStorageKey(boardId), JSON.stringify(blocks));
}

export function EditorView({ boardId }: { boardId: string }) {
  const initialContent = useMemo(() => loadContent(boardId), [boardId]);

  const editor = useCreateBlockNote({
    initialContent: initialContent && initialContent.length > 0 ? initialContent : undefined,
  });

  useEffect(() => {
    const handler = () => {
      saveContent(boardId, editor.document);
    };
    editor.onChange(handler);
  }, [editor, boardId]);

  return (
    <div className="h-full bg-white">
      <div className="max-w-4xl mx-auto py-8 px-4">
        <BlockNoteView editor={editor} theme="light" />
      </div>
    </div>
  );
}
